import React, { Component } from 'react'
import Chart from '@common/Chart'
import { toJS } from 'mobx'

export default class extends Component {
  render() {
    const { data = [], tab = '1' } = this.props

    let count_date = []
    let value = []
    for (let i in toJS(data)) {
      count_date.push(data[i].count_date)
      value.push(data[i].value)
    }

    // 曝光量: 1
    // 访问量: 2
    // CTR: 3
    // 停留时长: 4
    // 跳失率: 5
    // 转化数据: 6

    let yName
    let maxValue = 1
    if (tab == '1' || tab == '2') {
      yName = '次'
      maxValue = 1.5
    }

    if (tab == '3' || tab == '5') {
      yName = '%'
      maxValue = 2
    }

    if (tab == '4') {
      yName = 's'
      maxValue = 1.8
    }

    if (tab == 6) {
      yName = '次'
    }

    const option = {
      tooltip: {
        trigger: 'axis'
      },
      toolbox: {
        show: false
      },
      xAxis: {
        type: 'category',
        data: count_date
      },
      yAxis: {
        type: 'value',
        name: `单位(${yName})`,
        max: function(value) {
          return (value.max * maxValue).toFixed(0)
        },
        splitLine: { show: false }
      },
      series: [
        {
          data: value,
          type: 'line'
        }
      ],
      color: ['#448afc', '#2FC286']
    }
    return <Chart option={option} />
  }
}
